module.exports = __webpack_public_path__ + "44f79f8a986c979c8314dfb08cd369c4.svg";